import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AlertMessageModule} from "../../lib/alert-message/alert-message.module";
import {PasswordUpdateModalComponent} from "./password-update-modal.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import {ButtonModule} from "@xref/xref-lib";


@NgModule({
  declarations: [PasswordUpdateModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AlertMessageModule,
    TooltipModule,
    ButtonModule
  ],
  exports: [PasswordUpdateModalComponent]
})
export class PasswordUpdateModalModule {
}
